import React, { useState } from 'react';
import categories from 'data/can-store/categories';

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import SearchIcon from '@mui/icons-material/Search';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

function ModernSearchBar(): JSX.Element {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const [selectedCategory, setSelectedCategory] = useState<string>('All Category');

	const open = Boolean(anchorEl);

	const onOpenCategoryMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const onCloseCategoryMenu = () => {
		setAnchorEl(null);
	};

	const onClickCategory = (categoryName: string) => {
		setSelectedCategory(categoryName);
		onCloseCategoryMenu();
	};

	return (
		<Stack
			direction="row"
			spacing={1}
			sx={{
				border: `solid 1px var(--csmd-cl-border-primary)`,
				borderRadius: '30px',
			}}
		>
			<IconButton type="button">
				<SearchIcon sx={{ color: 'var(--csmd-cl-border-primary)' }} />
			</IconButton>
			<InputBase
				placeholder="Searching for ..."
				sx={{ minWidth: 400, color: 'var(--csmd-cl-text-primary)' }}
			/>
			<Button
				variant="contained"
				sx={{
					borderTopRightRadius: '30px',
					borderBottomRightRadius: '30px',
					textTransform: 'none',
					fontWeight: 'bold',
				}}
				endIcon={open ? <ExpandLess /> : <ExpandMore />}
				onClick={onOpenCategoryMenu}
			>
				{selectedCategory}
			</Button>
			<Menu anchorEl={anchorEl} open={open} onClose={onCloseCategoryMenu}>
				{categories.map((category) =>
					category.name !== selectedCategory ? (
						<MenuItem key={category.id} onClick={() => onClickCategory(category.name)}>
							{category.name}
						</MenuItem>
					) : null,
				)}
			</Menu>
		</Stack>
	);
}

export default ModernSearchBar;
